import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import DistributionTab from '../../components/DistributionTab';
import { DISTRIBUTION_FOR_DETAILS } from '../../constants/SmartInsightConstants';
import { useSavedSearchSelector } from '../../custom-hooks';
import { equalityFn } from '../../form-designer/utils/form-manager.utils';
import {
  addDistributionListItem,
  addDistributionListItems,
  deleteDistributionListItem,
  editSavedSearch,
  validateSavedSearch,
} from '../actions/editor.actions';
import { getSavedSearchProp, getSavedSearchTableRows } from '../selectors/editor.selectors';
import { getModifiedDistributionRows } from '../utils/common.utils';

const Distribution = () => {
  const dispatch = useDispatch();

  const distributionForValueStore = useSavedSearchSelector(getSavedSearchProp, {
    prop: 'distribution.distributionFor',
  });
  const distributionListRows = useSavedSearchSelector(
    getSavedSearchTableRows,
    { tablePath: 'distribution.distributionList' },
    equalityFn
  );

  const onChangeDistributionValue = ({ target }) => {
    if (distributionForValueStore === target.value) {
      return;
    }

    dispatch(editSavedSearch({ prop: 'distribution.distributionFor', value: target.value }));
    dispatch(editSavedSearch({ prop: 'distribution.distributionList', value: [] }));
    dispatch(validateSavedSearch());
  };

  const handleZoomSelectDistributionList = useCallback(
    ({ row, selection = [] }) => {
      if (selection.length) {
        const savedSearchDetails = DISTRIBUTION_FOR_DETAILS[distributionForValueStore];

        dispatch(deleteDistributionListItem({ rowId: row.rowId }));

        const rows = getModifiedDistributionRows({
          rows: selection,
          mappingFields: savedSearchDetails.mappingFields,
          distributionFor: distributionForValueStore,
        });

        dispatch(addDistributionListItems({ rows }));
        dispatch(validateSavedSearch());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [distributionForValueStore]
  );

  const handleAddNewDistributionRow = (data) => dispatch(addDistributionListItem(data));
  const handleDeleteNewDistributionRow = (data) => dispatch(deleteDistributionListItem(data));
  const handleValidateDistribution = () => dispatch(validateSavedSearch());

  return (
    <DistributionTab
      distributionForValueStore={distributionForValueStore}
      distributionListRows={distributionListRows}
      onChangeDistributionValue={onChangeDistributionValue}
      handleAddNewDistributionRow={handleAddNewDistributionRow}
      handleDeleteDistributionRow={handleDeleteNewDistributionRow}
      handleZoomSelectDistributionList={handleZoomSelectDistributionList}
      validateDistribution={handleValidateDistribution}
      isRightsShown
    />
  );
};

export default Distribution;
